import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './MobileNotice.css';

const DISMISSED_KEY = 'mobileNoticeDismissed';

const MobileNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isMobile =
      window.innerWidth > 0 && window.innerWidth <= 768 && isTouchDevice;
    const dismissed = sessionStorage.getItem(DISMISSED_KEY);
    if (isMobile && !dismissed) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return createPortal(
    <div className="mobile-notice-overlay">
      <div className="mobile-notice-content">
        <h2 className="mobile-notice-title">You're on mobile!</h2>
        <p className="mobile-notice-text">
          This site has animations and interactive effects that only work
          on desktop. Feel free to browse here, but visit on a bigger
          screen for the full experience.
        </p>
        <button className="mobile-notice-button" onClick={dismiss}>
          I understand
        </button>
      </div>
    </div>,
    document.body
  );
};

export default MobileNotice;
